import { request, userRequest } from '@/sdk/oauth'

export function validatePromoCode(promoCode: string): Promise<boolean> {
  return request
    .get(`/promotion/validate-promotion-code/${promoCode}`)
    .then(response => response.data)
}

export function submitPromoCode(payload: Object) {
  return userRequest
    .post('/customer/promotion-code', payload)
    .then(response => response.data)
}
